import { useNavigate } from 'react-router';
import snackIcon from '../../../assets/images/snack-shop/snack.png';
import timeCatIcon from '../../../assets/images/snack-shop/time-cat.png';
import lightningCatIcon from '../../../assets/images/snack-shop/lightning-cat.png';
import dividerIcon from '../../../assets/images/snack-shop/divider.svg';
import { goBackOrPlayground } from '../../../utils/navigation';
import SnackShopFrame from './SnackShopFrame';
import {
  LIGHTNING_DAILY_MAX,
  LIGHTNING_REWARD,
  LIGHTNING_SHOP_NO,
  SNACK_SHOP_NOTICES,
  maxSnackCount,
  remainingSnackCount,
} from './snackShopModel';
import { useSnackCharge, useSnackShopData } from './useSnackShop';

function CountPill({ label }) {
  return (
    <span className="flex h-[19px] items-center justify-center rounded-[12px] bg-black px-2 text-[12px] font-medium leading-[1.3] text-white">
      {label}
    </span>
  );
}

export default function SnackShopPage() {
  const navigate = useNavigate();
  const { ready, snackCount, lightningRemaining, slots, refresh } = useSnackShopData();
  const { busy, requestCharge } = useSnackCharge({ snackCount, onCharged: refresh });
  const timeMaxSnacks = slots.reduce((sum, item) => sum + maxSnackCount(item), 0);
  const timeRemainingSnacks = slots.reduce((sum, item) => sum + remainingSnackCount(item), 0);
  const todayMaxSnacks = timeMaxSnacks + LIGHTNING_DAILY_MAX;

  const chargeLightning = () => {
    if (lightningRemaining <= 0) return;
    requestCharge(LIGHTNING_SHOP_NO, LIGHTNING_REWARD);
  };

  if (!ready) {
    return <section className="min-h-screen w-full bg-[linear-gradient(180deg,#F0ECFF_3.42%,#D0C9FF_100%)]" />;
  }

  return (
    <SnackShopFrame title="간식 충전소" snackCount={snackCount} onBack={() => goBackOrPlayground(navigate)}>
      <div className="flex flex-col items-center px-2 pt-6">
        <div className="flex w-full max-w-[280px] flex-col items-center gap-[26px]">
          <div className="text-center text-[25px] font-bold leading-[1.4]">
            <p className="m-0 flex items-center justify-center gap-1">
              <span>맛있는 야옹</span>
              <img
                src={snackIcon}
                alt=""
                width={32}
                height={27}
                className="h-[27px] w-8 object-cover shadow-[1px_1px_5px_0px_#ffd362]"
              />
              <span>모아서</span>
            </p>
            <p className="m-0">푸짐한 보상 받자!!</p>
          </div>
          <div className="flex h-[30px] w-full items-center justify-center gap-1.5 rounded-[10px] bg-white shadow-[0px_2px_0.5px_rgba(0,0,0,0.25)]">
            <span className="text-[15px] font-bold text-[#717171]">오늘 최대</span>
            <img
              src={snackIcon}
              alt=""
              width={26}
              height={22}
              className="h-[22px] w-[26px] object-cover shadow-[1px_1px_5px_0px_#ffd362]"
            />
            <span className="text-[15px] font-bold text-[#717171]">{todayMaxSnacks.toLocaleString()}개 충전 가능</span>
          </div>
        </div>

        <div className="mt-[59px] flex w-full flex-col gap-[33px]">
          <button
            type="button"
            className="box-border flex w-full flex-col rounded-[10px] border-0 bg-white p-2.5 text-left shadow-[0px_4px_2px_rgba(0,0,0,0.25)]"
            onClick={() => navigate('/game/yaong-egg/shop/time')}
          >
            <div className="flex h-[105px] w-full items-center">
              <div className="flex min-w-0 flex-1 flex-col items-start gap-1.5">
                <span className="flex h-[21px] items-center justify-center rounded-[12px] bg-[#f0ecff] px-2 text-[12px] font-bold leading-[1.3] text-primary-blue">
                  간식 최대 {timeMaxSnacks.toLocaleString()}개
                </span>
                <p className="m-0 py-[5px] text-[16px] font-bold leading-[1.3]">
                  야옹 타임 간식 충전
                  <br />
                  6시간 마다 찾아오는 야옹간식
                </p>
                <CountPill label={`${timeRemainingSnacks}/${timeMaxSnacks}회`} />
              </div>
              <img src={timeCatIcon} alt="" width={110} height={86} className="h-[86px] w-[110px] shrink-0 object-contain" />
            </div>
          </button>

          <button
            type="button"
            className="box-border flex w-full flex-col rounded-[10px] border-0 bg-white p-2.5 text-left shadow-[0px_4px_2px_rgba(0,0,0,0.25)] disabled:opacity-60"
            onClick={chargeLightning}
            disabled={busy || lightningRemaining <= 0}
          >
            <div className="flex h-[105px] w-full items-center">
              <div className="flex min-w-0 flex-1 flex-col items-start gap-1.5">
                <span className="flex h-[21px] items-center justify-center rounded-[12px] bg-[#f0ecff] px-2 text-[12px] font-bold leading-[1.3] text-primary-blue">
                  간식 최대 {LIGHTNING_DAILY_MAX}개
                </span>
                <p className="m-0 py-[5px] text-[16px] font-bold leading-[1.3]">
                  번개 충전소
                  <br />
                  빠른 광고 보고 즉시 충전
                </p>
                <CountPill label={`${lightningRemaining}/${LIGHTNING_DAILY_MAX}회`} />
              </div>
              <img
                src={lightningCatIcon}
                alt=""
                width={110}
                height={86}
                className="h-[86px] w-[110px] shrink-0 object-contain"
              />
            </div>
          </button>
        </div>

        <img src={dividerIcon} alt="" width={360} height={21} className="mt-8 h-[21px] w-full max-w-[360px]" />

        <div className="mt-2 w-full px-1 text-[15px] text-black">
          <p className="m-0 font-bold tracking-[-0.3px]">유의 사항</p>
          <ul className="mb-0 mt-2 list-disc pl-5 leading-[1.7]">
            {SNACK_SHOP_NOTICES.map((notice) => (
              <li key={notice}>{notice}</li>
            ))}
          </ul>
        </div>
      </div>
    </SnackShopFrame>
  );
}
